import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SiterecordCharacteristics } from 'app/models';
import {
  LaneType,
  MeasurementCategoryType,
  MeasurementValueTypePoint,
  MeasurementValueTypePointVri
} from 'app/models/enums';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'point-details-specific-lane',
  templateUrl: './point-details-specific-lane.component.html',
  styleUrls: ['./point-details.component.scss']
})
export class PointDetailsSpecificLaneComponent implements OnInit {
  @Input() id: string;
  @Input() readonly: boolean;
  @Input() inputStyle: CbmInputStyle;
  @Input() siterecordCharacteristics: SiterecordCharacteristics;
  @Input() disabledLanes: string[];
  @Input() disabledMeasurementValuetypes: string[];

  @Output() changeSpecificLane: EventEmitter<string> = new EventEmitter<string>();

  public measurementValueTypes: string[];
  public measurementValueTypesVri: string[];
  public measurementCategoryTypes: string[];
  public specificLanes: string[];

  constructor() {}

  ngOnInit(): void {
    this.initialiseEnums();
  }

  private initialiseEnums(): void {
    this.specificLanes = enumValues(LaneType);
    this.measurementValueTypes = enumValues(MeasurementValueTypePoint);
    this.measurementValueTypesVri = enumValues(MeasurementValueTypePointVri);
    this.measurementCategoryTypes = enumValues(MeasurementCategoryType);
  }

  public onChangeSpecificLane() {
    this.changeSpecificLane.emit(this.siterecordCharacteristics.specificLane);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/point-details/general/point-details-specific-lane.component.ts